import {findStoreExtendedReport} from "../Util/queries";

export const getStoreExtendedReport = (date, companyId, callBack) =>
    async (dispatch) => {
        try {
            let response = await findStoreExtendedReport(companyId, date);

            if (response.data) {
                callBack(response.data.orders);
            } else {
                callBack(false);
            }
        } catch (e) {

        }
    }